<button class="back-bar" (click)="backClick.emit()">
  <img [src]="chevronPath()" alt="Zurück" width="24" height="24" />
  <span>Zurück zur Übersicht</span>
</button>
